/**
 * One workshop in the phone calendar's grid: a bar in its sub-region colour.
 *
 * A day column on a phone is too narrow for any text to survive, so the grid
 * only says how many workshops a day has and where. Tapping the day lists them
 * underneath, where there is room to read them.
 */
import { isCancelled } from '../../primitives/cancelled-workshops';
import { chipColors } from '../../primitives/workshops-calendar-chip-shared';
import type { RenderWorkshopSlotProps } from '../../primitives/workshops-calendar-render-context';

export function PhoneCalendarMarker({ workshop }: RenderWorkshopSlotProps) {
  const label = `${isCancelled(workshop) ? 'Cancelled: ' : ''}${workshop.venueName}`;
  return (
    <span
      role="img"
      aria-label={label}
      data-testid={`phone-calendar-marker-${workshop.id}`}
      style={{
        display: 'block',
        height: 6,
        marginTop: 3,
        borderRadius: 3,
        background: chipColors(workshop).border,
        opacity: isCancelled(workshop) ? 0.5 : 1,
      }}
    />
  );
}
